module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"selectColsTitle":"Choisir les colonnes visibles","visibleColumns":"Colonnes visibles","showAll":"tout afficher","fold":"plier","unfold":"déplier"},"en":{"selectColsTitle":"Chose visible columns","visibleColumns":"Visible columns","showAll":"show all","fold":"fold","unfold":"unfold"}}')
  delete Component.options._Ctor
}
